module.exports = __webpack_public_path__ + "assets/157af3128c7a304b60e7c30af648956a.svg";